import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g id="Clock-Icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group" transform="translate(4.000000, 4.000000)" stroke={color} strokeWidth="2">
        <circle id="Oval" cx="8" cy="8" r="8" />
        <polyline id="Path-20" points="8 3 8 8 11 8" />
      </g>
    </g>
  </svg>
);
